export default "__VITE_ASSET__Ch_A_2Ql__"